module.exports =
  '_SCORE_REGISTRATION':
    'TITLE': 'Score entry'
    'SELECT_CLUB':
      'TITLE': 'Select Club'
      'SEARCH': 'Search'
      'HISTORY': 'History'
      'NORESULT': "No Result."
      'COURSE_REQUEST_HINT': "If you can't find a course, please send request to add new course."
      'COURSE_REQUEST_LINK': 'Request'
      'INPUT_KEYWORDS': 'Input keywords'
      'EMAIL_SUBJECT': 'Course Request'
    'SELECT_CLUB_HISTORY':
      'NORESULT': "Rounds information Unregistered"
    'ROUND_INFO':
      'TITLE': 'Input Round Information'
      'HOLE_1': 'Hole 1'
      'HOLE_10': 'Hole 10'
      'COURSE_REQUEST': 'Please select a course'
      'START_REQUEST': 'Please select a start'
      'TEE_REQUEST': 'Please select a tee'
      'RAKUTEN_LINK': 'Reserve this golf course'
      'PLAY_DATE': 'Play date'
      'WEATHER': 'Weather'
      'COURSE': 'Course'
      'START_HOLE': 'Start'
      'TEE_POSITION': 'Tee Position'
      'EXTRA_9': 'Extra 9'
      'NONE': 'None'
      'MOVE_TO_SELECT_PLAYERS': 'Next: Add / Save Players'
      'CONFIRM_CLEAR_DATA': 'The data you entered below this field will be cleared. Are you sure?'
      'ERROR_FLASH_MESSAGE': 'There are some errors on your input. Please check again.'
    'SELECT_PLAYERS':
      'SELECT_PLAYER_TITLE': 'Add / Save Players'
      'PARTNER': 'Partner'
      'MOVE_TO_SCORE_REGISTRATION': 'Next: Enter Score'
      'DUPLICATE_PLAYER': 'This name is already registered. Please input another name.'
      'CONFIRM_CLEAR_SCORE': 'The score data for this player will be cleared. Are you sure?'
    'SCORE_ENTRY':
      'TITLE': 'Enter Score'
    'FOOTER':
      'TITLE': 'Complete'
    'UNSAVED_HINT': 'Click OK to apply your changes.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/i18n/en.coffee